import { z } from 'zod';
/** Persona types — matches Prisma PersonaType enum + Q7 personas. */
export const PersonaSchema = z.enum([
    'CAREGIVER',
    'FACILITY_USER',
    'HOMECARE_CLIENT_USER',
    'OPERATOR',
]);
/** User status — matches Prisma UserStatus enum. */
export const UserStatusSchema = z.enum(['ACTIVE', 'SUSPENDED', 'DISABLED']);
/** Single role assignment surfaced to the client.
 *  entityRef is null for OPERATOR; for CAREGIVER/FACILITY_USER/HOMECARE_CLIENT_USER
 *  it's the UUID of the corresponding domain entity (caregiver / facility / homecare_client). */
export const RoleAssignmentSchema = z.object({
    persona: PersonaSchema,
    entityRef: z.string().uuid().nullable(),
    isPrimary: z.boolean(),
});
/** GET /api/v1/auth/me response. */
export const AuthMeResponseSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    displayName: z.string().nullable(),
    status: UserStatusSchema,
    totpEnrolled: z.boolean(),
    /** Whether the CURRENT session has satisfied TOTP (submitted a valid code
     *  since sign-in). When totpEnrolled is true and this is false, every
     *  persona surface is gated (403 totp_verification_required) until the user
     *  completes the second factor — the portal prompts for the code. */
    totpSatisfied: z.boolean(),
    /** Whether the account has a password set. Magic-link-only users have
     *  none — the UI then offers "Set a password" instead of "Change password". */
    hasPassword: z.boolean(),
    roles: z.array(RoleAssignmentSchema),
});
/** PATCH /api/v1/auth/me request — the signed-in user editing their own account
 *  profile. Email is immutable (not editable); phone is a future field. */
export const UpdateAuthProfileSchema = z.object({
    displayName: z.string().trim().min(1).max(120),
});
//# sourceMappingURL=me.schema.js.map